<gk-dynamic-list [listConfigs]="listConfigs"></gk-dynamic-list>
